import React from 'react';
import PropTypes from 'prop-types';
import TooltipedIconButton from './Base/TooltipedIconButton';

function EditButton({ onClick, id, text }) {
  return (
    <TooltipedIconButton
      text={text}
      onClick={onClick}
      id={id}
      className="btn btn-outline-light"
      icon="fa fa-pencil"
    />
  );
}

EditButton.propTypes = {
  onClick: PropTypes.func.isRequired,
  id: PropTypes.string.isRequired,
  text: PropTypes.string.isRequired,
};

export default EditButton;
